import { Link } from "@mui/material";

//Common Styles
import {
  HorizontalContainer,
  HorizontalLine,
  SectionHeader,
  SectionTitle,
  ShowLabel,
  ShowValue,
  ThreeColGrid,
  WorkspacePanel,
  WorkspaceSection,
  WorkSpaceTitleRow,
} from "../../styles/commonStyles";

//Icons
import { CityIcon, HouseIcon, LocationIcon } from "../Svg";

const ChefForPartyLocationDetails = ({ record }: { record: any }) => {
  return (
    <WorkspacePanel>
      <WorkspaceSection>
        <SectionHeader>
          <WorkSpaceTitleRow>
            <LocationIcon />
            <SectionTitle>Location Details</SectionTitle>
          </WorkSpaceTitleRow>
        </SectionHeader>
      </WorkspaceSection>

      <ThreeColGrid>
        <HorizontalContainer>
          <HouseIcon color={"#6C7C93"} width={16} height={16} />
          <ShowLabel style={{ marginBottom: "0px" }}>House ID:</ShowLabel>
          <Link href={`/#/Houses/${record?.house?.id}/show`}>
            {record?.house?.id}
          </Link>
        </HorizontalContainer>
        <HorizontalContainer>
          <CityIcon color={"#6C7C93"} width={16} height={16} />
          <ShowLabel style={{ marginBottom: "0px" }}>City:</ShowLabel>
          <Link href={`/#/Cities/${record?.cityId}/show`}>
            {record?.cityName}
          </Link>
        </HorizontalContainer>
        <HorizontalContainer>
          <LocationIcon color={"#6C7C93"} width={16} height={16} />
          <ShowLabel style={{ marginBottom: "0px" }}>Area:</ShowLabel>
          <Link href={`/#/Areas/${record?.areaId}/show`}>
            {record?.areaName}
          </Link>
        </HorizontalContainer>
      </ThreeColGrid>

      <HorizontalLine  />

        <HorizontalContainer>
          <ShowLabel style={{ marginBottom: "0px" }}>Locality:</ShowLabel>
          <Link href={`/#/Localities/${record?.localityId}/show`}>
            {record.localityName || "-"}
          </Link>
        </HorizontalContainer>
        <HorizontalLine  />
        <HorizontalContainer>
        <ShowLabel style={{ marginBottom: "0px" }}>Address:</ShowLabel>
        <ShowValue>
          {record?.house?.fullAddress || "-"}
        </ShowValue>
      </HorizontalContainer>

      
    </WorkspacePanel>
  );
};

export default ChefForPartyLocationDetails;
